import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('precio');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed bottom-0 left-0 w-full z-50 p-4 bg-gradient-to-t from-offwhite via-offwhite to-transparent pb-6" data-id="element-23">
      <div className="max-w-md mx-auto" data-id="element-24">
        <motion.button onClick={scrollToPricing} animate={{
        scale: [1, 1.03, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="w-full bg-cta hover:bg-cta-hover text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-2 text-lg border-b-4 border-green-700 active:border-b-0 active:translate-y-1 transition-all" style={{
        boxShadow: '0 4px 14px 0 rgba(34,139,34,0.4), 0 2px 4px 0 rgba(0,0,0,0.15)'
      }} data-id="element-25">
          ¡SÍ, QUIERO DESINFLAMARME AHORA!
          <ArrowRight className="w-5 h-5" data-id="element-26" />
        </motion.button>
      </div>
    </div>;
}